module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, _vm._l((_vm.userList), function(item) {
    return _c('div', {
      key: item.uid,
      staticClass: "agent-list"
    }, [_c('h4', [_vm._v("\n        " + _vm._s(item.uid) + "\n        "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "agent-list-id"
    }, [_vm._v("\n          ( id_\n          "), _c('span', [_vm._v("xjioa355bhhd")]), _vm._v(" )\n        ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.uid == _vm.$router.app.$store.state.user.uid),
        expression: "item.uid == $router.app.$store.state.user.uid "
      }],
      staticClass: "badge agent-list-badge"
    }, [_vm._v("Me")]), _vm._v(" "), (_vm.isAdmin) ? _c('button', {
      staticClass: "btn btn-warning btn-sm btn-agent-edit pull-right",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.handleEditPrivilege(item)
        }
      }
    }, [_vm._v("Privileges")]) : _vm._e(), _vm._v(" "), (item.permission < _vm.currentUserPermission || _vm.$router.app.$store.state.user.pm > 888) ? _c('button', {
      staticClass: "btn btn-info btn-sm btn-agent-edit pull-right",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.toEditUser(item)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e()]), _vm._v(" "), (item.permission >= 888) ? _c('span', [_c('i', {
      staticClass: "fa fa-star"
    }), _vm._v(" Admin\n      ")]) : _c('span', [_c('i', {
      staticClass: "fa fa-star-o"
    }), _vm._v(" User\n      ")])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminInApp),
      expression: "isAdminInApp"
    }],
    staticClass: "add-app-bgcolor dropup"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right add-btn-dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "add-agent-choose",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-add-existing-agent"
    },
    on: {
      "click": _vm.toGetExistUser
    }
  }, [_vm._v("Add Existing Agents")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "add-agent-choose",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.toShowNewUserModal
    }
  }, [_vm._v("New An Agent")])])])]), _vm._v(" "), _c('privilege-modal', {
    ref: "privilegeModal"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-edit-agent"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Agent ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.uid),
      expression: "editUser.uid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Agent uid",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.editUser.uid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUser, "uid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.password),
      expression: "editUser.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Keep the current password"
    },
    domProps: {
      "value": (_vm.editUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUser, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("E-mail Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.email),
      expression: "editUser.email"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "E-mail Address..."
    },
    domProps: {
      "value": (_vm.editUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editUser, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Agent's Authority")]), _vm._v(" "), (_vm.$router.app.$store.state.user.pm > 888) ? _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.permission),
      expression: "editUser.permission"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUser, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])]) : _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editUser.permission),
      expression: "editUser.permission"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editUser, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Delete Agent")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-left alert-del"
  }, [_vm._m(2), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.toDeleteUser
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toUpdataUser
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-an-agent"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Agent ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.uid),
      expression: "newUser.uid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Necessary"
    },
    domProps: {
      "value": (_vm.newUser.uid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "uid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Necessary"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label agent-edit-modal-name"
  }, [_vm._v("E-mail Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Necessary"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.currentUserPermission > 888) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Agent's Authority")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 agent-edit-modal-name control-label"
  }, [_vm._v("Agent's Authority")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 agent-edit-modal-name"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.permission),
      expression: "newUser.permission"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toNewUser
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-add-existing-agent"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "choose-existing-agent-table table-striped"
  }, _vm._l((_vm.existedUser), function(item) {
    return _c('tbody', {
      key: item.uid
    }, [_c('tr', {
      staticClass: "choose-existing-agent-row",
      attrs: {
        "role": "row"
      }
    }, [(item.hasAdd == true) ? _c('td', {
      staticClass: "col-xs-1 choose-existing-agent-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.isCheck),
        expression: "item.isCheck"
      }],
      staticClass: "choose-existing-agent-checkbox-input",
      attrs: {
        "type": "checkbox",
        "checked": "",
        "disabled": ""
      },
      domProps: {
        "checked": Array.isArray(item.isCheck) ? _vm._i(item.isCheck, null) > -1 : (item.isCheck)
      },
      on: {
        "change": function($event) {
          var $$a = item.isCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "isCheck", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "isCheck", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "isCheck", $$c)
          }
        }
      }
    })]) : (item.isCheck == true) ? _c('td', {
      staticClass: "col-xs-1 choose-existing-agent-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.isCheck),
        expression: "item.isCheck"
      }],
      staticClass: "choose-existing-agent-checkbox-input",
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(item.isCheck) ? _vm._i(item.isCheck, null) > -1 : (item.isCheck)
      },
      on: {
        "change": function($event) {
          var $$a = item.isCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "isCheck", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "isCheck", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "isCheck", $$c)
          }
        }
      }
    })]) : _c('td', {
      staticClass: "col-xs-1 choose-existing-agent-checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.isCheck),
        expression: "item.isCheck"
      }],
      staticClass: "choose-existing-agent-checkbox-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.isCheck) ? _vm._i(item.isCheck, null) > -1 : (item.isCheck)
      },
      on: {
        "change": function($event) {
          var $$a = item.isCheck,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "isCheck", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "isCheck", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "isCheck", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-4"
    }, [_c('span', [_vm._v("Agent ID: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.uid))])]), _vm._v(" "), (_vm.$router.app.$store.state.user.pm > 888 && item.hasAdd != true) ? _c('td', {
      staticClass: "col-xs-5"
    }, [_c('span', [_vm._v("Authority: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.permission),
        expression: "item.permission"
      }],
      staticClass: "choose-existing-agent-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])]) : _c('td', {
      staticClass: "col-xs-5"
    }, [_c('span', [_vm._v("Authority: ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.permission),
        expression: "item.permission"
      }],
      staticClass: "choose-existing-agent-select",
      attrs: {
        "disabled": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("Admin")]), _vm._v(" "), _c('option', [_vm._v("User")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSelectAll),
      expression: "!isSelectAll"
    }],
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSelectAllExistUser
    }
  }, [_vm._v("Select All")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSelectAll),
      expression: "isSelectAll"
    }],
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toSelectAllExistUser
    }
  }, [_vm._v("DeSelect All")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toAddExistUser
    }
  }, [_vm._v("Save changes")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "add-app-btn",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit Agent's Authority")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to delete ?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit Agent's Authority")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Add Existing Agents")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7dff9c0e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dff9c0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Agent.vue
// module id = 487
// module chunks = 1